module.exports = __webpack_public_path__ + "5e5fa07842f76a4c91b1dc6377d8975f.png";